import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { ButtonForm, CustomTextField } from 'Components/Form/styles';
import { Column, Row } from 'Components/Grid';
import { InputLoader } from 'Components/PageLoader/Input';
import { MuiChipsInput } from 'mui-chips-input';
import { Controller } from 'react-hook-form';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getUsersName } from 'services/users-service';
import { useAuthTenant } from 'store/auth';
import { useTranslation } from 'react-i18next';

export const Detalhes = ({ handleNext, register, control, handleSubmit, errors, getValues, id }) => {
  const { t } = useTranslation('mapping');
  const selectedTenant = useSelector(useAuthTenant);
  const navigate = useNavigate();
  const onSubmit = () => {
    handleNext();
  };

  const { data: users, isLoading: userLoading } = useQuery(['getUsers'], async () => {
    const result = await getUsersName(selectedTenant.slug);
    return result?.data.length > 0 ? result?.data : [];
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Row justifyContent="center">
        <Column xs={12} md={6} className="d-flex">
          <div data-tour="process-name" style={{ width: '100%' }}>
            <CustomTextField
              {...register('name', { required: t('processes.form.validation.nameRequired') })}
              label={t('processes.form.fields.name')}
            autoFocus
            error={errors?.name ? true : false}
            sx={{ minHeight: '48px', margin: '0 auto 24px', width: '100%' }}
            helperText={errors?.name ? errors.name.message : null}
            InputLabelProps={{ shrink: true }}
            disabled={!!id}
          />
          </div>
        </Column>
        <Column xs={12} md={6} className="d-flex">
          <div data-tour="process-criticity" style={{ width: '100%' }}>
            <Controller
              control={control}
              rules={{
              validate: () => {
                return getValues('criticity') !== '';
              },
              required: t('processes.form.validation.criticalityRequired'),
            }}
            name="criticity"
            render={({ field: { onChange, value } }) => {
              const criticitiesData = [
                { value: '1', color: '#4caf50', label: t('processes.form.criticityLabels.1') },
                { value: '2', color: '#8bc34a', label: t('processes.form.criticityLabels.2') },
                { value: '3', color: '#ff9800', label: t('processes.form.criticityLabels.3') },
                { value: '4', color: '#ff5722', label: t('processes.form.criticityLabels.4') },
                { value: '5', color: '#f44336', label: t('processes.form.criticityLabels.5') }
              ];
              const selectedCriticity = criticitiesData.find(item => item.value === value);
              
              return (
                <FormControl fullWidth sx={{ marginBottom: '24px' }} error={errors?.criticity ? true : false}>
                  <InputLabel id="criticity-label" shrink>
                    {t('processes.form.fields.criticality')}
                  </InputLabel>
                  <Select
                    labelId="criticity-label"
                    id="criticity"
                    value={value}
                    label={t('processes.form.fields.criticality')}
                    onChange={onChange}
                    notched
                    renderValue={(selected) => {
                      if (!selected) return t('processes.list.filters.selectCriticality');
                      return (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <div
                            style={{
                              width: '12px',
                              height: '12px',
                              borderRadius: '50%',
                              backgroundColor: selectedCriticity?.color || '#ccc'
                            }}
                          />
                          {selected} - {selectedCriticity?.label}
                        </div>
                      );
                    }}
                  >
                    <MenuItem value="" key={-1}>
                      {' '}
                      {t('processes.list.filters.selectCriticality')}{' '}
                    </MenuItem>
                    {criticitiesData.map((item, index) => (
                      <MenuItem value={item.value} key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <div
                          style={{
                            width: '12px',
                            height: '12px',
                            borderRadius: '50%',
                            backgroundColor: item.color,
                            marginRight: '8px'
                          }}
                        />
                        {item.value} - {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{errors?.criticity ? errors.criticity.message : ''}</FormHelperText>
                </FormControl>
              );
            }}
          />
          </div>
        </Column>
      </Row>
      <Row>
        <Column xs={12} md={6} className="d-flex">
          <div data-tour="process-user" style={{ width: '100%' }}>
            {!userLoading && (
              <Controller
              control={control}
              rules={{
                validate: () => {
                  return getValues('user') !== '';
                },
                required: t('processes.form.validation.responsibleRequired'),
              }}
              name="user"
              render={({ field: { onChange, value } }) => (
                <FormControl fullWidth sx={{ marginBottom: '24px' }} error={errors?.user ? true : false}>
                  <InputLabel id="user-label" shrink>
                    {t('processes.form.fields.responsible')}
                  </InputLabel>
                  <Select labelId="user-label" id="user" value={value} label={t('processes.form.fields.responsible')} onChange={onChange} notched>
                    <MenuItem value="" key={-1}>
                      {t('processes.list.filters.selectResponsible')}
                    </MenuItem>
                    {users
                      ?.map(user => user.name)
                      .map((item, index) => (
                        <MenuItem value={item} key={`user-${index}`}>
                          {item}
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText>{errors?.user ? errors.user.message : ''}</FormHelperText>
                </FormControl>
              )}
            />
          )}
          {userLoading && (
            <FormControl fullWidth sx={{ margin: '0 auto 24px' }}>
              <InputLabel id="user-label" shrink={true}>
                {t('processes.form.fields.responsible')}
              </InputLabel>
              <InputLoader />
            </FormControl>
          )}          </div>        </Column>
        <Column xs={12} md={6} className="d-flex">
          <FormControl fullWidth sx={{ margin: '0 auto 24px' }} data-tour="process-tags">
            <Controller
              control={control}
              name="tags"
              render={({ field: { onChange, value } }) => (
                <MuiChipsInput
                  label={t('processes.form.fields.tags')}
                  value={value}
                  onChange={onChange}
                  InputLabelProps={{ shrink: true }}
                  placeholder={t('processes.form.placeholders.tags')}
                  renderChip={(Component, props) => {
                    return (
                      <Component
                        {...props}
                        variant="outlined"
                        color="primary"
                        sx={{
                          width: 'fit-content',
                        }}
                      />
                    );
                  }}
                  sx={{
                    '& .MuiButtonBase-root.MuiChip-root.MuiChip-filled': {
                      width: 'fit-content',
                    },
                    '& .MuiButtonBase-root.MuiIconButton-root': {
                      width: 'fit-content',
                      marginTop: '0px',
                    },
                  }}
                />
              )}
            ></Controller>
          </FormControl>
        </Column>
      </Row>
      <Row>
        <Column>
          <div data-tour="process-description" style={{ width: '100%' }}>
            <TextField
              {...register('description', {
                required: t('processes.form.validation.descriptionRequired'),
              })}
              label={t('processes.form.fields.description')}
            multiline
            rows={4}
            error={errors?.description ? true : false}
            helperText={errors?.description ? errors.description.message : null}
            sx={{ margin: '0 auto 24px', width: '100%' }}
            InputLabelProps={{ shrink: true }}
          />
          </div>
        </Column>
      </Row>
      <Row>
        <Column>
          <div data-tour="process-dataflow" style={{ width: '100%' }}>
            <TextField
              {...register('descriptionDataFlow', {
                required: t('processes.form.validation.dataFlowRequired'),
              })}
              label={t('processes.form.fields.descriptionDataFlow')}
            multiline
            rows={4}
            error={errors?.descriptionDataFlow ? true : false}
            helperText={errors?.descriptionDataFlow ? errors.descriptionDataFlow.message : null}
            sx={{ margin: '0 auto 8px', width: '100%' }}
            InputLabelProps={{ shrink: true }}
          />
          </div>
        </Column>
      </Row>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }} data-tour="process-checkboxes">
        <Controller
          control={control}
          name="dpia"
          render={({ field: { onChange, value } }) => (
            <FormControlLabel
              value={value}
              control={<Checkbox checked={value} onChange={onChange} name="dpia" />}
              label="DPIA"
              sx={{ marginLeft: 0, marginBottom: 0 }}
            />
          )}
        />
        <Controller
          control={control}
          name="lia"
          render={({ field: { onChange, value } }) => (
            <FormControlLabel
              value={value}
              control={<Checkbox checked={value} onChange={onChange} name="lia" />}
              label="LIA"
              sx={{
                marginLeft: 0,
                marginBottom: 0,
                '& .MuiTypography-root': {
                  whiteSpace: 'nowrap',
                },
              }}
            />
          )}
        />
        <Controller
          control={control}
          name="dataTreatmentFromChildrenTeenagerElderly"
          render={({ field: { onChange, value } }) => (
            <FormControlLabel
              value={value}
              control={
                <Checkbox checked={value} onChange={onChange} name="dataTreatmentFromChildrenTeenagerElderly" />
              }
              label={t('processes.form.checkboxes.dataTreatmentVulnerable')}
              sx={{
                marginLeft: 0,
                marginBottom: 0,
                '& .MuiTypography-root': {
                  whiteSpace: 'nowrap',
                },
              }}
            />
          )}
        />
      </Box>
      <Row justifyContent="end" alignItems="center">
        <Column xs={4} md={3} className="d-flex" style={{ gap: '8px', justifyContent: 'flex-end' }}>
          <div data-tour="form-actions" style={{ display: 'flex', gap: '8px', width: '100%', justifyContent: 'flex-end' }}>
            <ButtonForm secondary id="cancel" label={t('processes.form.buttons.cancel')} onClick={() => navigate('/processes')}></ButtonForm>
            <ButtonForm label={t('processes.form.buttons.save')} type="submit" />
          </div>
        </Column>
      </Row>
    </form>
  );
};
